var Encoding = (function () {
    function Encoding() {
    }
    Encoding.isSupportedEncoding = function (encoding) {
        return Encoding.SUPPORTED_ENCODINGS.indexOf(encoding) >= 0;
    };
    Encoding.isPlainJson = function (encoding) {
        return Encoding.PLAIN_JSON_ENCODINGS.indexOf(encoding) >= 0;
    };
    Encoding.isCompressedJson = function (encoding) {
        return Encoding.COMPRESSED_ENCODINGS.indexOf(encoding) >= 0;
    };
    Encoding.SUPPORTED_ENCODINGS = ['jsjson-v2', 'jsjsonc-v2'];
    Encoding.PLAIN_JSON_ENCODINGS = ['jsjson-v2'];
    Encoding.COMPRESSED_ENCODINGS = Encoding.SUPPORTED_ENCODINGS.filter(function (enc) { return enc.indexOf('jsonc') >= 0; });
    return Encoding;
}());
export { Encoding };
//# sourceMappingURL=Encoding.js.map